import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import UserMenu from '../auth/UserMenu';
import SubscriptionStatus from '../user/SubscriptionStatus';
import FirebaseConnectionStatus from '../common/FirebaseConnectionStatus';
import GPSStatusIndicator from '../tracking/GPSStatusIndicator';
import NotificationCenter from '../notifications/NotificationCenter';
import { useAuth } from '../../contexts/AuthContext';

export default function Header() {
  const { user } = useAuth();

  return (
    <header className="bg-western-tan-400 border-b-4 border-western-brown-600 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2 relative">
            <img src="/cow-icon.svg" alt="RanchWorkUSA" className="h-8 w-8" />
            <div className="walking-cow">
              <img src="/cow-icon.svg" alt="Cow" className="walking-icon-img" />
            </div>
            <div className="walking-farmer">
              <img src="/farmer-icon.svg" alt="Farmer" className="walking-icon-img" />
            </div>
            <div className="walking-cow">
              <img src="/cow-icon.svg" alt="Cow" className="walking-icon-img" />
            </div>
            <div className="walking-farmer">
              <img src="/farmer-icon.svg" alt="Farmer" className="walking-icon-img" />
            </div>
            <span className="text-xl font-bold text-western-brown-900">RanchWorkUSA</span>
          </Link>
          <Navigation />
          <div className="flex items-center space-x-3">
            <GPSStatusIndicator />
            {user && <NotificationCenter />}
            <UserMenu />
          </div>
        </div>

        {user && (
          <div className="pb-4">
            <SubscriptionStatus />
          </div>
        )}

        <FirebaseConnectionStatus />
      </div>
    </header>
  );
}
